var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 17.5V16.625C4.375 15.0005 5.02031 13.4426 6.16897 12.294C7.31763 11.1453 8.87555 10.5 10.5 10.5M10.5 10.5C12.1245 10.5 13.6824 11.1453 14.831 12.294C15.9797 13.4426 16.625 15.0005 16.625 16.625V17.5M10.5 10.5C11.4283 10.5 12.3185 10.1313 12.9749 9.47487C13.6313 8.8185 14 7.92826 14 7C14 6.07174 13.6313 5.1815 12.9749 4.52513C12.3185 3.86875 11.4283 3.5 10.5 3.5C9.57174 3.5 8.6815 3.86875 8.02513 4.52513C7.36875 5.1815 7 6.07174 7 7C7 7.92826 7.36875 8.8185 8.02513 9.47487C8.6815 10.1313 9.57174 10.5 10.5 10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.39e869697d11924e4d523e5f4fc0fcb7.svg";
export { ForwardRef as ReactComponent };